import { useLang } from "@/context/LanguageContext";

const CONTENT = {
  ar: {
    title: "سياسة الخصوصية",
    updated: "آخر تحديث: يوليو 2026",
    intro:
      "في ARTLENSS، خصوصيتك جزء من أمانتنا الفنّية. نحن استوديو إنتاج سينمائي مقره جدة، ونلتزم بحماية أي معلومات تُشاركها معنا عبر موقعنا artlenss.com. هذه السياسة توضّح البيانات التي نجمعها، وكيف نستخدمها، وحقوقك الكاملة تجاهها.",
    sections: [
      {
        h: "١. البيانات التي نجمعها",
        p: "نجمع بيانات محدودة تكفي لتقديم خدماتنا فقط: (أ) بيانات التواصل التي تُدخلها طوعاً في نموذج الاتصال — الاسم، البريد الإلكتروني، رقم الجوال، الشركة، ونوع المشروع. (ب) بيانات تصفّح غير شخصية عبر ملفات تعريف الارتباط (Cookies) وأدوات التحليل مثل Google Analytics — تشمل نوع المتصفح، الجهاز، البلد، الصفحات التي تزورها، ومدة الجلسة. (ج) لا نطلب أبداً أي بيانات مالية أو رقم هوية أو معلومات حساسة.",
      },
      {
        h: "٢. لماذا نستخدم بياناتك",
        p: "نستخدم بياناتك لأغراض تشغيلية بحتة: الردّ على استفساراتك، إعداد عروض الأسعار، تحسين تجربة الموقع وسرعته، قياس أداء صفحاتنا لمعرفة المحتوى الأكثر فائدة للزوّار، وعرض إعلانات مدروسة عبر Google AdSense إذا كانت مفعّلة. لا نبيع بياناتك ولا نُشاركها لأغراض تسويقية خارجية أبداً.",
      },
      {
        h: "٣. ملفات تعريف الارتباط والإعلانات",
        p: "يستخدم موقعنا ملفات تعريف الارتباط لتشغيل ميزات أساسية (تفضيل اللغة العربية/الإنجليزية) وللتحليلات. كما نستخدم Google AdSense، وقد تعرض جوجل إعلانات مخصّصة اعتماداً على زيارتك السابقة لموقعنا أو مواقع أخرى. يمكنك إيقاف الإعلانات المخصّصة عبر إعدادات إعلانات جوجل: adssettings.google.com — دون التأثير على تجربة التصفح لدينا.",
      },
      {
        h: "٤. مشاركة البيانات مع أطراف ثالثة",
        p: "نستعين بمزوّدي خدمات موثوقين فقط لتشغيل الموقع، مثل Google Analytics للتحليلات، Google AdSense للإعلانات، وخدمات الاستضافة السحابية. جميع هؤلاء ملزَمون بسياسات خصوصية صارمة، ولا يصل أيّ منهم إلى بياناتك الشخصية إلا لتقديم الخدمة المتفق عليها.",
      },
      {
        h: "٥. حماية البيانات",
        p: "نطبّق تشفير HTTPS على كل صفحات الموقع، ونحدّ من الوصول الداخلي إلى بيانات التواصل بحيث لا يطّلع عليها إلا فريق الاستوديو المختص بالردّ. لا نحتفظ بأي بيانات تواصل أكثر مما يلزم للمشروع أو المتابعة معك.",
      },
      {
        h: "٦. حقوقك",
        p: "لك الحق في: (أ) طلب نسخة من بياناتك، (ب) تصحيحها إذا كانت غير دقيقة، (ج) طلب حذفها بالكامل من سجلاتنا، (د) الاعتراض على استخدامها لأغراض تسويقية. للتواصل بأي طلب من هذه الحقوق، أرسل بريداً إلى info@artlenss.com وسنستجيب خلال ٧ أيام عمل كحدّ أقصى.",
      },
      {
        h: "٧. حقوق المحتوى البصري",
        p: "جميع الصور والفيديوهات المنشورة على الموقع مملوكة لـ ARTLENSS أو لعملائنا بعد إذن مسبق. لا يجوز إعادة استخدامها تجارياً بدون إذن كتابي. عند تصويرنا لمشاريع تحتوي على أشخاص، نحصل دائماً على موافقة كتابية (Talent Release) قبل النشر.",
      },
      {
        h: "٨. الأطفال",
        p: "خدماتنا موجّهة للجمهور العام والعملاء التجاريين. لا نجمع بيانات من أطفال دون سن الـ ١٣ عن قصد. إذا اكتشفت أن طفلاً أرسل بيانات، تواصل معنا فوراً وسنحذفها.",
      },
      {
        h: "٩. التعديلات على هذه السياسة",
        p: "قد نحدّث هذه السياسة من وقت لآخر عند إضافة خدمات جديدة أو تغييرات قانونية. سنُشير إلى تاريخ آخر تحديث أعلى الصفحة، ونستمر بالعمل بالنسخة الأحدث فور نشرها.",
      },
      {
        h: "١٠. التواصل معنا",
        p: "لأي سؤال يخصّ الخصوصية أو طلب متعلّق ببياناتك، تواصل معنا مباشرة: info@artlenss.com — أو عبر رقم الاستوديو +٩٦٦ ٥٥ ٤١٤ ٢٠٠٧ · جدة، المملكة العربية السعودية.",
      },
    ],
  },
  en: {
    title: "Privacy Policy",
    updated: "Last updated: July 2026",
    intro:
      "At ARTLENSS, your privacy is part of our creative integrity. We are a cinematic production studio based in Jeddah, Saudi Arabia, and we are committed to protecting any information you share with us through artlenss.com. This policy explains what we collect, how we use it, and the full rights you retain over your data.",
    sections: [
      {
        h: "1. What We Collect",
        p: "We collect only the data required to serve you: (a) contact details you voluntarily submit through the contact form — name, email, phone, company, and project type; (b) non-personal browsing data through cookies and analytics tools such as Google Analytics — browser type, device, country, pages visited, and session duration; (c) we never request financial data, national IDs, or any sensitive personal information.",
      },
      {
        h: "2. How We Use Your Data",
        p: "Your data is used strictly for operational purposes: responding to inquiries, preparing quotations, improving site speed and experience, measuring page performance to understand which content is most useful to visitors, and serving relevant ads through Google AdSense where enabled. We never sell your data and never share it for third-party marketing.",
      },
      {
        h: "3. Cookies & Advertising",
        p: "Our site uses cookies for essential functions (language preference AR/EN) and for analytics. We also use Google AdSense, which may serve personalized ads based on your prior visits to our site or others. You can opt out of personalized ads at adssettings.google.com without affecting your experience on our site.",
      },
      {
        h: "4. Sharing With Third Parties",
        p: "We rely only on trusted service providers to operate the site — Google Analytics for analytics, Google AdSense for advertising, and cloud hosting providers. All are bound by strict privacy policies and access your data only to deliver the agreed service.",
      },
      {
        h: "5. Data Protection",
        p: "We enforce HTTPS across every page and restrict internal access to inquiry data to the studio team members responsible for reply. We retain no more contact data than necessary to complete the project or follow-up.",
      },
      {
        h: "6. Your Rights",
        p: "You have the right to: (a) request a copy of your data, (b) correct it if inaccurate, (c) request its full deletion from our records, (d) object to marketing use. To exercise any of these rights, email info@artlenss.com — we respond within 7 business days.",
      },
      {
        h: "7. Visual Content Rights",
        p: "All images and videos published on this site are owned by ARTLENSS or by our clients with prior permission. Commercial re-use without written consent is prohibited. Whenever we film people, we obtain a written Talent Release before publication.",
      },
      {
        h: "8. Children",
        p: "Our services target the general public and commercial clients. We do not knowingly collect data from children under 13. If you believe a child has submitted data, contact us and we will delete it immediately.",
      },
      {
        h: "9. Updates to This Policy",
        p: "We may update this policy from time to time when adding new services or in response to legal changes. The 'Last updated' date at the top will reflect the latest version, effective immediately upon publication.",
      },
      {
        h: "10. Contact Us",
        p: "For any privacy-related question or a request concerning your data, reach us at info@artlenss.com — or by phone +966 55 414 2007 · Jeddah, Saudi Arabia.",
      },
    ],
  },
};

const Privacy = () => {
  const { lang } = useLang();
  const c = CONTENT[lang];
  return (
    <div data-testid="privacy-page">
      <section className="pt-32 pb-10 md:pt-40 md:pb-14">
        <div className="container-x max-w-4xl">
          <div className="overline mb-6">ARTLENSS · Legal</div>
          <h1 className="display-h1">{c.title}</h1>
          <p className="mt-6 text-white/50 text-sm uppercase tracking-[0.24em]">{c.updated}</p>
          <p className="mt-10 text-white/80 text-lg md:text-xl leading-relaxed">{c.intro}</p>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="container-x max-w-4xl space-y-10">
          {c.sections.map((sec, i) => (
            <article key={i} className="border-t border-white/10 pt-8">
              <h2 className="font-display text-2xl md:text-3xl text-[#E6A95B] mb-4">{sec.h}</h2>
              <p className="text-white/75 text-lg leading-[1.9]">{sec.p}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Privacy;
